<template>
  <div class="mb-12">
    <label class="font-bold block mb-2">Versjoner</label>
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 mt-3 gap-6">
      <button
        v-for="(t, i) in types"
        @click="() => setCurrrent(i)"
        :key="i"
        :class="[
          'flex flex-col gap-2 transition-colors',
          {
            'border border-gray-300 dark:border-gray-600 p-4 w-full ':
              t.description,
          },
          {
            'border-gray-600 dark:border-gray-300':
              t.description && current == i,
          },
        ]"
      >
        <div class="flex gap-3 cursor-pointer">
          <input type="checkbox" :checked="i == current" />
          <div class="check check--big">
            <IconCheck />
          </div>
          <div class="text-base font-semibold">
            {{ t.type }}
          </div>
        </div>
        <div
          v-if="t.description"
          v-html="t.description"
          class="w-full mt-2 text-left car-details"
        ></div>
      </button>
    </div>
  </div>
</template>

<script>
import IconCheck from '../partials/IconCheck';

export default {
  name: 'CarTypes',
  props: ['types'],
  emits: ['toggleCarType'],
  components: { IconCheck },
  data: () => ({
    current: 0,
  }),
  mounted() {
    this.$emit('toggleCarType', { index: 0 });
  },
  methods: {
    setCurrrent(index) {
      this.current = index;
      this.$emit('toggleCarType', { index });
      this.$nextTick(() => {
        $(
          `.car-color-picker[data-type="${index}"] button:first-of-type()`
        ).click();
      });
    },
  },
};
</script>
